import React from 'react';
import { connect } from 'react-redux';
import { withContent } from '../../../hoc/withContext';
import { IAppSliceConfig, IContent } from '../../../types';
import './GamesSliderBlock.scss';

// @ts-ignore
import Slider from 'react-slick';

import Loader from '../../Elements/Loader/Loader';
import PrevArrow from '../../Elements/Sliders/PrevArrow';
import NextArrow from '../../Elements/Sliders/NextArrow';
import Title from '../../Elements/Title/TitleElement';

import sliderConfig from './sliderConfig';
import GameSliderCardElement from '../../Elements/GameSliderCard/GameSliderCardElement';
import { cleanSpaces, getProductById } from '../../../utils';

interface IGamesSliderBlockProps {
	config: IAppSliceConfig;
	context?: IContent;
	initialized: any;
	products: any;
}

const GamesSliderBlock = ({ config, context, initialized, products }: IGamesSliderBlockProps) => {
	const productsCategory = 'games_list';

	const { games_slider } = context;
	const { is_active, title } = games_slider;

	const productsItems = initialized && config.currency && products
		? games_slider.items.map((item: any, index: number) => {
			const productFound = getProductById(products, cleanSpaces(item.product.product_id), item.product.product_type);
			return productFound ? (
				<GameSliderCardElement key={index} index={index} info={item} product={productFound} />
			) : null;
		})
		: null;

	return is_active && (
		<div className="block-games_list">
			<Title>{title}</Title>
			{!initialized ? (
				<Loader />
			) : productsItems.length > 0 ? (
				<Slider
					className={productsCategory}
					{...sliderConfig}
					prevArrow={<PrevArrow />}
					nextArrow={<NextArrow />}
				>
					{productsItems}
				</Slider>
			) : null}
		</div>
	);
};

const mapStateToProps = (state: any) => ({
	config: state.app.config,
	initialized: state.app.initialized,
	products: state.products.data
});

export default connect(mapStateToProps)(withContent(GamesSliderBlock));
